import React, { useEffect, useState, useCallback } from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { selectFocusedRequest, isLoading } from "../../selectors";
import { setBreadcrumbs } from "../../actions";
import { useNavigate, useParams } from "react-router-dom";
import {
  cancelRequest,
  denyRequest,
  approveRequest,
  resolveIdentity,
} from "../../actions";
import { RequestDetails } from "@authzsvc/common-react-components";
import { errorAction, types as at } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../utils";

const RequestDetailsWrapper = (props) => {
  const {
    breadcrumbs,
    setBreadcrumbs,
    cancelRequest,
    approveRequest,
    denyRequest,
    resolveIdentity,
  } = props;

  const navigate = useNavigate();
  const { id } = useParams();

  const requestData = useSelector((state) => selectFocusedRequest(state, id));

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [breadcrumbs, setBreadcrumbs]);

  const [request, setRequest] = useState(requestData.request);
  const [requestor, setRequestor] = useState({});

  const getRequestor = useCallback(
    async (id) => {
      if (id) {
        let req = await resolveIdentity(id);
        setRequestor(req.payload.data);
      }
    },
    [resolveIdentity],
  );

  // Set the request data as it changes
  useEffect(() => {
    if (!request && requestData.request) {
      setRequest(requestData.request);
    }
  }, [request, requestData, getRequestor]);

  // Fetch the requestor after setting the request object
  useEffect(() => {
    const fetchOwner = async () => {
      if (request?.requestorId) {
        await getRequestor(request.requestorId);
      }
    };
    fetchOwner();
  }, [request, getRequestor]);

  const goBack = () => {
    navigate("/requests");
  };

  const handleAction = async (actionFn, actionType, reason) => {
    const resp = await actionFn(requestData.request.id, reason);
    if (resp.type === errorAction(actionType)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
    goBack();
  };

  const handleCancel = () => {
    handleAction(cancelRequest, at.CANCEL_REQUEST);
  };

  const handleApprove = (reason) => {
    handleAction(approveRequest, at.APPROVE_REQUEST, reason);
  };

  const handleDeny = (reason) => {
    handleAction(denyRequest, at.DENY_REQUEST, reason);
  };

  return (
    <>
      {request && (
        <RequestDetails
          {...props}
          request={
            request
              ? { ...request, requestorName: requestor.displayName }
              : null
          }
          toApprove={requestData?.toApprove}
          onApprove={handleApprove}
          onCancel={handleCancel}
          onDeny={handleDeny}
        />
      )}
    </>
  );
};

RequestDetailsWrapper.propTypes = {
  requestData: PropTypes.object,
  cancelRequest: PropTypes.func,
  approveRequest: PropTypes.func,
  denyRequest: PropTypes.func,
  resolveIdentity: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
};

export default connect(
  (state) => ({
    loading:
      isLoading(state, "cancelRequest") ||
      isLoading(state, "approveRequest") ||
      isLoading(state, "denyRequest"),
  }),
  {
    setBreadcrumbs,
    cancelRequest,
    denyRequest,
    approveRequest,
    resolveIdentity,
  },
)(RequestDetailsWrapper);
